var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgJoinArenaArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 12 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0.75 5.25H11.25M11.25 5.25L6.75 0.75M11.25 5.25L6.75 9.75",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgJoinArenaArrow;